<template>
     <div id="binding" class="main-container">
           <!-- <div class="uilts"></div> -->
      <div id="login"  class="hidden-sm-and-down">
          <div class="imgbox">
          <img src="../assets/biglogo.png" alt="">
          <span class="title">欢迎登录刘燕酿制官网</span>
        </div>
        <div class="formcontainer">
          <el-form :model="form" status-icon :rules="rules" ref="loginForm" class="login-box">
            <el-form-item prop="tel">
              <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" maxlength="11" type="text" v-model.number="form.tel" ref="phone" @keyup.enter.native="passLogin('loginForm')" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号" autocomplete="on"/>
            </el-form-item>
            <el-form-item prop="telcode" >
              <el-input  onkeyup="this.value=this.value.replace(/\D+/g,'')" style="width: 65%;float: left" v-model="form.telcode" type="telcode" @keyup.enter.native="codeLogin('loginForm')" label-width="80px" placeholder="输入验证码" autocomplete="off" ref="telcode" prefix-icon="el-icon-lock"></el-input>
              <el-button class="aa" style="width: 30%;height: 41px;background:#00383F;color: #fff; padding:12px 0; float: right;" @click="send">
                <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
                <span style="" v-if="!sendMsgDisabled">获取验证码</span>
              </el-button>
            </el-form-item>
    
            <el-button class="bnt" type="primary" v-on:click="codeLogin('loginForm')" >登录</el-button>
          </el-form>
        </div>
      </div>
    </div>
</template>

<script>
import {PostLoginAPI,send_code_API,binding_url} from '@/request/api.js'
export default {
    name: 'NewLiuyanShopWebBinding',
    data() {
      let checkTel = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('手机号不能为空'));
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('请输入正确的手机号'));
          }
        }
      };
      return{
        sendMsgDisabled: false,
        time: '60',
        form: {
          tel: '',
          telcode:''
        },
        // 表单验证，需要在 el-form-item 元素中增加 prop 属性
        rules: {
          tel: [
            {validator: checkTel, trigger: 'blur'},
            { type: 'number', message: '手机号必须为数字'}
          ],
          telcode: [
            {required: true, message: '验证码不可为空', trigger: 'blur'},
            { min: 6, max: 6, message: '验证码为6位数字', trigger: 'blur' }
          ],
        },
      }
    },

    mounted() {
        
    },

    methods: {
        // 发送验证码
        send() {
        let me = this;
        me.sendMsgDisabled = true;
        let userInfo = {
          'phone': this.$refs.phone.value,
          'lostatus': 'wechat'
        };
        let phone = this.$refs.phone.value;
        if (phone === "" || userInfo.phone.length < 11) {
          this.$message.error("请输入正确手机号");
          me.sendMsgDisabled = false;
          return false
        } else {
          let interval = window.setInterval(function () {
            if ((me.time--) <= 0) {
              me.time = 60;
              me.sendMsgDisabled = false;
              window.clearInterval(interval);
            }
          }, 1000);
        }
        send_code_API(userInfo).then((res)=>{
            console.log(res.data)
            if(res.data.code == '200'){
              this.$message.success(res.data.message);
            }else{
              this.$message.success(res.data.message);
            }
          
        })
      },
    //   登录
       codeLogin() {
        let postParams = {
          "phone": this.$refs.phone.value,
          "code": this.$refs.telcode.value,
        };
        if (postParams.phone === '' || postParams.code === '') {
          this.$message.error("请输入完整信息");
          return false;
        }else {
          if(this.sendMsgDisabled==true){
            if (postParams.code.length < 6 || postParams.code.length > 6) {
              this.$message.error('请输入6位验证码');
              return false;
            } else {
              binding_url(postParams).then((res)=>{
                  console.log(res)
                this.login_success('code', res, postParams);
              })
            }
          }else {
            return false;
          }
        }
      },
        // 登陆后动作
         login_success(type, data, userInfo) {
            if (data.data.code === 100) {
            if (type === 'pass') {
                this.$message.error(data.data.message);
            }
            if (type === 'code') {
                this.$message.error(data.data.message);
                this.form.telcode = ''
            }
            }else if (data.data.code === 200) {
            let token = data.data.data.token
            let tokenDate = new Date().getTime();
            //请求成功保存用户登录信息到localStorage和Vuex中
            this.$cookies.set('tokenDate', tokenDate,3600);
            localStorage.setItem('userToken', token);
            this.$store.dispatch('setLogin', token);
            this.$message.success('登录成功');
            this.$store.dispatch('getCarCount');
            this.$router.push({path: '/Information'})
            }
     
      },
    },
};
</script>

<style lang="less" scoped>
#binding{
  display: flex;
  align-items: center;
  justify-content: center;
}
   #login{
     width: 100%;
     padding: 0  0 100px 0;
     box-sizing: border-box;
      display: flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    .el-button--primary:focus,
    .el-button--primary:hover{
      background: #00383F;
      border-color: #00383F;
      border-radius: 5px;
    }
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus,
    .el-form-item.is-success .el-input__inner,
    .el-form-item.is-success .el-input__inner:focus,
    .el-form-item.is-success .el-textarea__inner,
    .el-form-item.is-success .el-textarea__inner:focus{
      border-color: #00383F;
    }
  .formcontainer {
    max-width: 400px;
    margin: 0 auto;
    width: 40%;
  }

  .hidden {
    width: 100%;
    height: 250px;
  }

  .login-box {
    margin: 0 auto;
  }

  .imgbox {
    width: 60%;
    // margin: 5% 0 0;
    margin: 0 auto;
  }

  .imgbox img {
    width: 285px;
    height: 70px;
    margin-top: 5%;
  }

  .login_a {
    width: 100%;
    height: 40px;
  }

  .title {
    display: block;
    text-align: center;
    padding: 2% 0 2% 0;
    font-size: 20px;
    font-weight: bold;
  }

  .bnt {
    width: 155px;
    height: 40px;
    color: #fff;
    border-radius: 4px;
    background: #00383F;
    border: none;
  }
  }

@media (max-width: 991px) {
  .phonelogin{
    padding-top: 1rem;
    margin: 0 0.5rem;
    .title{
      font-size: 0.4rem;
      font-weight: 900;
      color: #00383F;
      padding-bottom: 0.79rem;
    }
    .bnt{
      width: 100%;
      background: #00383F;
      color: #fff;
      height: 0.89rem;
      font-size: 0.33rem;
      font-weight: 900;
      border-radius:unset;
    }
    .login_a{
      margin-top: 0.41rem;
      overflow: hidden;
      span{
        color: #00383F;
        font-size: 0.26rem;
        float: left;
        cursor: default;
      }
      a{
        color: #00383F;
        font-size: 0.26rem;
        float: right;
      }
    }
    .treelogin{
      text-align: center;
      margin-top: 0.6rem;
        span{
          width: 2.35rem;
          height: 0.01rem;
          background: #00383F;
          display: inline-block;
        }
        p{
          display: inline-block;
          font-size: 0.26rem;
          vertical-align: -webkit-baseline-middle;
        } 
    }
    .treeimg{
      padding-top: 1rem;
      display: flex;
      padding-bottom: 1rem;
      div{
        width: 50%;
      }
    }
   
  }
  /deep/.el-input__inner{
    height: 0.8rem;
    font-size: 0.24rem;
    border-radius: unset;
    border: 1px solid #00383F;

  }
    /deep/.el-input__inner::placeholder{
     text-align: left;
     font-size: 0.24rem;
   }
}

</style>


// WEBPACK FOOTER //
// src/view/binding.vue